import { render, staticRenderFns } from "./addDialogFromTable.vue?vue&type=template&id=52331ba0&scoped=true&"
import script from "./addDialogFromTable.vue?vue&type=script&lang=js&"
export * from "./addDialogFromTable.vue?vue&type=script&lang=js&"
import style0 from "./addDialogFromTable.vue?vue&type=style&index=0&id=52331ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52331ba0",
  null
  
)

export default component.exports